import { ReactComponent as CloseIcon } from 'app/assets/img/bold_close_icon.svg';
import { ReactComponent as LocationIcon } from 'app/assets/img/icon_Location_Detail_Show.svg';
import { ReactComponent as TimeIcon } from 'app/assets/img/icon_Time_Detail_Show.svg';
import ModalContainer from 'app/components/ModalContainer';
import React, { memo, useMemo } from 'react';
import styled from 'styled-components';
import TooltipParagraph from '../tooltipParagraph';
import { formatDescriptionCatalog } from './helper';
interface Props {
  isShow: boolean;
  onCloseDialog: () => void;
  detailShow: any;
}

const DialogDetailShow = memo(
  ({ isShow, onCloseDialog, detailShow }: Props) => {
    const isMobile = window.innerWidth < 1200;
    const formattedDescription = useMemo(
      () => formatDescriptionCatalog(detailShow?.description ?? ''),
      [detailShow?.description],
    );
    return (
      <ModalContainer
        isShow={!!isShow}
        onCloseDialog={onCloseDialog}
        maskClosable={false}
        modalProps={{
          destroyOnClose: true,
        }}
        modalPadding="32px 30px 12px"
        modalHeight="auto"
        CloseIcon={<CloseIcon />}
        styleSlots={{
          modalContentStyle: {
            width: isMobile ? '100%' : '636px',
            maxWidth: '636px',
            height: 'auto',
            padding: '32px 30px 12px',
          },
          bodyStyle: {
            overflow: 'auto',
            padding: '0px',
            marginRight: '-42px',
            marginLeft: '-42px',
          },
          iconWrapperStyle: {
            margin: 0,
          },
        }}
      >
        <Title>{detailShow?.name}</Title>
        <StyledContent>
          <StyledGroup>
            <LocationIcon style={{ flexShrink: 0 }} />
            <StyledTextName>{detailShow?.park?.name}</StyledTextName>
          </StyledGroup>
          {detailShow?.note ? (
            <StyledGroup>
              <TimeIcon style={{ flexShrink: 0 }} />
              <StyledText>{detailShow?.note}</StyledText>
            </StyledGroup>
          ) : null}
        </StyledContent>
        <Description
          dangerouslySetInnerHTML={{
            __html: formattedDescription,
          }}
        />
      </ModalContainer>
    );
  },
);
export default DialogDetailShow;
const Title = styled(TooltipParagraph)`
  color: #000;
  margin: 0 0 8px 4px;
  font-size: 16px;
  font-weight: 600;
`;
const StyledContent = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
  margin-top: 8px;
`;
const StyledGroup = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  margin-bottom: 8px;
`;
const StyledText = styled.div`
  font-style: italic;
  color: #808080;
  font-size: 14px;
  margin-left: 4px;
`;
const StyledTextName = styled.div`
  color: #808080;
  font-size: 14px;
  margin-left: 4px;
`;
const Description = styled.div`
  color: #000;
  margin-bottom: 10px;
  text-align: justify;
  white-space: pre-line;
`;
